/**
 * The two methods ADR 0002 named. Called directly on `contentWindow.__player`
 * — there is no injected script, because this destination *is* the browser.
 */
export interface PlayerApi {
  ready: Promise<unknown>;
  loadScoreXML(xml: string): void;
  seekSeconds(t: number): void;
}

export async function loadScore(api: PlayerApi, xml: string): Promise<void> {
  await api.ready;
  api.loadScoreXML(xml);
  // Open paused at the start: reload() keeps a running transport playing.
  api.seekSeconds(0);
}

export async function bindPlayer(
  win: Window,
  xml: string,
  timeoutMs = 30_000,
): Promise<void> {
  const deadline = Date.now() + timeoutMs;
  while (Date.now() < deadline) {
    const api = (win as Window & { __player?: PlayerApi }).__player;
    if (api) {
      await loadScore(api, xml);
      return;
    }
    await new Promise((resolve) => setTimeout(resolve, 50));
  }
  throw new Error('Player did not become ready.');
}
